import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NonStaticInterceptor } from './nonstatic.http-interceptor';

@Injectable()
export class JsonHttpInterceptor extends NonStaticInterceptor implements HttpInterceptor {
  protected internalIntercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let reqHeaders = req.headers;
    if (!reqHeaders.has('Content-Type')) {
      reqHeaders = reqHeaders.set('Content-Type', 'application/json;charset=UTF-8');
    }
    if (!reqHeaders.has('Accept')) {
      reqHeaders = reqHeaders.set('Accept', 'application/json;charset=UTF-8');
    }
    const jsonReq = req.clone({
      headers: reqHeaders
    });
    return next.handle(jsonReq);
  }
}
